import { render, staticRenderFns } from "./CostsGroupUnit.vue?vue&type=template&id=17ed1a3a&scoped=true&"
import script from "./CostsGroupUnit.vue?vue&type=script&lang=js&"
export * from "./CostsGroupUnit.vue?vue&type=script&lang=js&"
import style0 from "./CostsGroupUnit.vue?vue&type=style&index=0&id=17ed1a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed1a3a",
  null
  
)

export default component.exports